import { Selector } from "react-redux";
import { createSelector } from "reselect";

import { IAppState } from "@multiweb/types/react";
import { getOpenedFormsInfo } from "../openedItems";
import { getFormItems, getProfiles } from "../selectors";
import { IMenuItems, OpenedFormHistoryInfoArray } from "../types";

const getModel: Selector<IAppState, IMenuItems> = (state) => state.menu.items;

/**
 * Získá celou historii otevřených formulářů.
 * @param state
 */
const getHistoryFormsInfo: Selector<IAppState, OpenedFormHistoryInfoArray> = (state) => getModel(state).historyFormsInfo;

/**
 * Získá historii otevřených formulářů filtrovanou podle položek a profilů, na které má uživatel oprávnění.
 */
const getAllowedFormsHistoryInfo = createSelector<
    IAppState,
    ReturnType<typeof getHistoryFormsInfo>,
    ReturnType<typeof getFormItems>,
    ReturnType<typeof getProfiles>,
    OpenedFormHistoryInfoArray
>(
    getHistoryFormsInfo,
    getFormItems,
    getProfiles,
    (historyFormsInfo, formItems, profiles) => {
        return historyFormsInfo
            .filter((historyForm) => {
                const formItem = formItems[historyForm.menuItemId];
                if (formItem) {
                    return true;
                }
                return historyForm.profileId ? !!profiles[historyForm.profileId] : false;
            });
    },
);

/**
 * Získá seznam id formulářů a profilů otevřených v minulosti. Výsledek je filtrován, aby neobsahoval aktuálně otevřené položky.
 * @param state
 */
export const getOpenedFormsHistoryInfo = createSelector<IAppState,
    ReturnType<typeof getAllowedFormsHistoryInfo >,
    ReturnType<typeof getOpenedFormsInfo>,
    OpenedFormHistoryInfoArray
>(
    getAllowedFormsHistoryInfo,
    getOpenedFormsInfo,
    (historyFormsInfo, openedFormsInfo) =>
        historyFormsInfo
            .filter((historyForm) =>
                !openedFormsInfo.find((openedForm) =>
                    openedForm.menuItemId === historyForm.menuItemId && openedForm.profileId === historyForm.profileId)),

);
